"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _common = require("b2b-components/theme/components/CMS/common");
var _Modal = require("b2b-components/theme/components/Modal");
var _Video = require("b2b-components/theme/components/Video");
var _VideoPlay = require("b2b-components/theme/components/VideoPlay");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Card.scss");
const Card = _ref => {
  let {
    videoUrl,
    imageUrl,
    videoThumbnailUrl,
    title,
    cta,
    bottomHtmlText,
    topHtmlText,
    size = _common.CMS_SIZING.size100,
    isVideoModalOpened,
    onCtaClick,
    onVideoModalClose,
    onVideoPlayClick,
    dataAttributes,
    className
  } = _ref;
  if (!(bottomHtmlText || cta || imageUrl || title || topHtmlText || videoThumbnailUrl)) {
    return null;
  }
  const rootClassName = (0, _classnames.default)('cds-cms-Card', `cds-cms-Card--${size}`, className);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "cds-cms-Card-Title"
  }, title), topHtmlText && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: topHtmlText
    }
  }), (!!imageUrl || !!videoThumbnailUrl) && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-Card-Figure"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-Card-FigureBody"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: title || '',
    className: "cds-cms-Card-FigureImage",
    src: imageUrl || videoThumbnailUrl
  }), videoUrl && /*#__PURE__*/_react.default.createElement(_VideoPlay.VideoPlay, {
    onClick: onVideoPlayClick
  }))), bottomHtmlText && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: bottomHtmlText
    }
  }), cta && cta.text && cta.url && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-Card-Button"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: () => onCtaClick(),
    size: _Button.BUTTON_SIZE.small,
    styleType: _Button.BUTTON_STYLE_TYPE.primary
  }, cta.text))), videoUrl && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    content: () => /*#__PURE__*/_react.default.createElement(_Video.Video, {
      videoUrl: videoUrl
    }),
    isOpen: isVideoModalOpened,
    onCloseModal: onVideoModalClose,
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map